<template>
    <div>
  
      <v-flex xs12>
        <div style="display: flex; align-items: center">
          <v-flex>
            <Typography h2 bold :label="$t('หน่วยราคา')" />
          </v-flex>
          <v-btn
            variant="outlined"
            icon
            :color="'#BECCDB'"
            style="border-radius: 50% !important"
            @click="addUnit = true"
          >
            <img :src="`/static/img/Add.png`" alt class="responsive-img" style="height: 14px" />
          </v-btn>
        </div>
      </v-flex>
  
      
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <div v-else>
        <v-data-table
          :headers="headers"
          :items="showData"
          hide-actions
          select-all
          item-key="name"
          :pagination.sync="pagination"
          class="fixTable"
        >
          <template v-slot:headers="props">
            <tr style="background-color: #152d53; color: white">
              <th
                style="background-color: #152d53; color: yellow; text-align: left"
                v-for="(header, k) in props.headers"
                :key="header.text + k"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr class="py-3 depatable">
              <td class="text-xs-left">
                <Typography left h5 :label="props.item.id || '-'" />
              </td>
              <td class="text-xs-left">
                <Typography left h5 :label="props.item.unit || '-'" />
              </td>
              <td class="text-xs-center" style="width: 70px">
              
                <TooltipTable
                  :datas="props"
                  @modalEdit="clickUpdate(props.item)"
                  @Delete="deleteUnit(props.item.id)"
                  showDelete
                ></TooltipTable>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    
      <v-dialog v-if="addUnit" persistent v-model="addUnit" max-width="500">
        <v-card>
          <div class="text-xs-right">
            <v-btn fab small flat @click="addUnit = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-layout class="mx-3 pb-3" column>
            <Typography class="mb-2" h2 bold label="เพิ่ม Unit" />
            <div>
              <Typography h5 semiBold label="ชื่อ Unit*" />
              <div class="form-control px-1 pb-2" :class="{ 'has-error': errors.has('unit name') }">
                <input
                  type="text"
                  v-model="createUnit.unit"
                  placeholder="กรอกชื่อ unit"
                  class="form-control"
                  maxlength="255"
                  name="unit name"
                  v-validate="'required'"
                />
                <p class="text-error" v-if="errors.has('unit name')">
                  {{ errors.first('unit name') }}
                </p>
              </div>
            </div>           
            <div style="display: flex; justify-content: center" class="mt-3">
              <Button :loading="loading" outline :label="$t('cancel')" @click="addUnit = false" />
              <Button :loading="loading" depressed :label="$t('Save')" @click="saveUnit" />
            </div>
          </v-layout>
        </v-card>
      </v-dialog>
      <v-dialog v-if="updateUnit" persistent v-model="updateUnit" max-width="500">
        <v-card>
          <div class="text-xs-right">
            <v-btn fab small flat @click="updateUnit = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-layout class="mx-3 pb-3" column>
            <Typography class="mb-2" h2 bold label="แก้ไข Unit" />
            <Typography h5 semiBold label="Unit*" />
            <div class="form-control px-1 pb-2" :class="{ 'has-error': errors.has('unit name') }">
              <input
                v-model="updateUnitData.unit"
                placeholder=""
                type="text"
                class="depainput rsu "
                maxlength="20"
                :name="'unit name'"
                data-vv-as="unit name"
                v-validate="'required'"
              />
                <p class="text-error" v-if="errors.has('unit name')">
                  {{ errors.first('unit name') }}
                </p>
              </div>
           
            <div style="display: flex; justify-content: center" class="mt-3">
              <Button :loading="loading" outline :label="$t('cancel')" @click="updateUnit = false" />
              <Button :loading="loading" depressed :label="$t('Save')" @click="fetchupdateUnit" />
            </div>
          </v-layout>
        </v-card>
      </v-dialog>
      <Paginations
        @clickPagination="changepage"
        @sortPage="sortPage"
        :pageCount="pageCount"
        :numberPage="numberPage"
        :page="page"
      />
    </div>
  </template>
  
  <script>
  import Multiselect from 'vue-multiselect'
  import api from '@/api'
  import InputSearch from '@/components/elements/InputSearch.vue'
  import Typography from '@/components/elements/Typography.vue'
  import TooltipTable from '@/components/elements/TooltipTable.vue'
  import Button from '@/components/elements/Button.vue'
  import Paginations from '@/components/elements/Paginations.vue'
  import uploadalltype from '@/components/elements/uploadalltype'
  import uploadfile from '@/components/elements/uploadfiletest.vue'
  import DropdownMenu from '@/components/elements/DropdownMenu.vue'
  
  export default {
    components: {
      Multiselect,
      InputSearch,
      Typography,
      TooltipTable,
      Button,
      Paginations,
      uploadalltype,
      uploadfile,
      DropdownMenu
    },
    data() {
      return {
        filter: {
          nameAll: ''
        },
        loading: false,
        searchText: '',
        addUnit: false,
        updateUnit: false,
        pagination: {
          descending: false,
          sortBy: 'name',
          rowsPerPage: 999
        },
        createUnit: {
          unit: ''
        },
        headers: [
          { text: 'ID', align: 'center', value: 'id' },
          { text: this.$t('หน่วย'), align: 'center', value: 'unit' },
          { text: '', align: 'center', value: 'delete' }
        ],
        updateUnitData: {
          unit: '',
          id: null
        },
        typeList: [],
        data: [],
        showData: [],
        error: false,
        page: 1,
        pageTotal: 0,
        rowsPerPage: 12,
        numberPage: {
          page: undefined
        },
      }
    },
    computed: {
      pageCount() {
        if (this.pageTotal !== 0) {
          let count = Math.ceil(this.pageTotal / this.rowsPerPage)
          return count
        } else {
          return 0
        }
      },
      limitCom() {
        return this.rowsPerPage
      },
      offsetCom() {
        return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
      }
    },
    mounted() {
      this.setupData()
    },
    methods: {
      update(key, value) {
        this.$emit('input', { ...this.value, [key]: value })
      },
      async changepage(pages) {
        this.page = parseInt(pages)
        this.numberPage.page = undefined
        this.loading = true
        await this.getUnit()
        this.loading = false
      },
      async sortPage(pages) {
        let count = Math.ceil(this.pageTotal / this.rowsPerPage)
        if (pages == '' || Number(pages <= 0) || pages > Number(count)) return
        if (pages) {
          this.page = parseInt(pages)
          this.loading = true
          await this.getUnit()
          this.loading = false
        }
      },
      async onSearch() {
        this.loading = true
        this.page = parseInt(1)
        await this.getUnit()
        this.loading = false
      },
      setupData() {
        this.getUnit()
        this.getTag()
      },
      changeSort(column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      clickUpdate(data) {
        this.updateUnitData.unit = data.unit
        this.updateUnitData.id = data.id
        this.updateUnit = true
      },
      async deleteUnit(id) {
        this.$swal
          .fire({
            type: 'question',
            text: 'ยืนยันการลบ?',
            showCancelButton: true
          })
          .then(async result => {
            if (result.value) {
              let res = await api.deleteUnit(id)
              if (res == 200) {
                this.getUnit()
              }else if (res==400){
                this.$swal.fire({
                    type: 'error',
                    text: 'ไม่สามารถลบ Unit ได้'
                })
              }
            }
          })
      },
      async saveUnit() {
        var isValid = await this.$validator.validate()
        if (isValid && this.createUnit.unit) {
          let obj = {
            unit: this.createUnit.unit,
          }
          let res = await api.createUnit(obj)
          if (res == 200) {
            this.createUnit.unit = ''
            this.addUnit = false
            this.error = false
            this.$swal.fire({
              type: 'success',
              title: '<div class="headline primary--text bold7 fs-24">บันทึกข้อมูลสำเร็จ</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
            this.getUnit()
          }
        } else {
          this.error = true
        }
      },
      async fetchupdateUnit() {
        if (this.updateUnitData.unit && this.updateUnitData.id) {
          let obj = {
            unit: this.updateUnitData.unit,
          }
          let res = await api.updateUnit(this.updateUnitData.id, obj)
          if (res == 200) {
            this.updateUnitData = {
              unit: '',
              id: null
            }
            this.updateUnit = false
            this.error = false
            this.$swal.fire({
              type: 'success',
              title: '<div class="headline primary--text bold7 fs-24">แก้ไขข้อมูลสำเร็จ</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
            this.getUnit()
          }
        } else {
          this.error = true
        }
      },
      async getUnit() {
        this.loading = true
        try {
          var params = {
            nameAll: this.filter.nameAll ? this.filter.nameAll : null,
            limit: this.limitCom,
            offset: this.offsetCom
          }
          this.data = await api.getdepaUnitId(params)
          
          this.loading = false
          this.showData = this.data.data
          this.pageTotal = this.data.total ? this.data.total : []
        } catch (error) {
          console.error(error)
        }
      },
      searchByText(text) {
        if (text == '') {
          this.showData = this.data
          return
        }
        let output = []
        this.data.forEach(ele => {
          if (ele.unit.toLowerCase().match(text.toLowerCase())) {
            output.push(ele)
          }
        })
        this.showData = output
      },
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .fixTable table.v-table {
    thead {
      tr {
        th:last-child {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          filter: drop-shadow(0px 2px 5px #d9d9d9);
        }
        th:last-child::after {
          content: '';
          border-left: 0;
        }
      }
    }
    tbody {
      tr {
        td:last-child {
          position: sticky !important;
          position: -webkit-sticky !important;
          background: #ffffff;
          right: 0;
          filter: drop-shadow(0px 2px 5px #d9d9d9);
        }
        td:last-child::after {
          content: '';
          border-left: 0;
        }
      }
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/view/techhuntMaster/Unit.vue